import React from "react";
import { Epg, Layout } from "planby";

// Import hooks
import { useApp } from "./useApp";

// Import components
import { Timeline, ChannelItem, ProgramItem } from "./components";

function ProgramGuide() {
  const { isLoading, getEpgProps, getLayoutProps, isBaseTimeFormat } = useApp();

  return (
    <div className="container" style={{ paddingTop: "70px" }}>
      <div style={{ height: "90vh", width: "100%" }}>
        <Epg isLoading={isLoading} {...getEpgProps()}>
          <Layout
            {...getLayoutProps()}
            renderTimeline={(props) => <Timeline {...props} />}
            renderProgram={({ program, ...rest }) => (
              <ProgramItem
                key={program.data.id}
                program={program}
                isBaseTimeFormat={isBaseTimeFormat}
                {...rest}
              />
            )}
            renderChannel={({ channel }) => (
              <ChannelItem key={channel.uuid} channel={channel} />
            )}
          />
        </Epg>
      </div>
    </div>
  );
}

export default ProgramGuide;
